import './App.css';
import Main from './components/Main';
import { Navbar } from './components/Navbar';

function App() {
  return (
    <>
   <Navbar/>
   <Main/>
   </>
  );
}

export default App;
